import TimePicker from 'material-ui/TimePicker';
import globals from '../../../globals/communityGlobals';

class TimePickerWrapper extends TimePicker {
  openDialog() {
    const { time } = this.state;
    this.setState({
      dialogTime: time || globals.now.toDate(),
    });
    this.refs.dialogWindow.show();
  }
}

export default TimePickerWrapper;
